import React from "react";
// Register Rule Book

// Default
import { useState } from "react";

// Mui
import Card from "@mui/material/Card";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import Grid from "@mui/material/Grid2";
import CardHeader from "@mui/material/CardHeader";
import Divider from "@mui/material/Divider";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import Box from "@mui/material/Box";
import Link from "@mui/material/Link";

// Custom
import Layout from "../../layout";
import ContainedButton from "../../forms/button/ContainedButton";
import CustomSearchBox from "../search/SearchBox";
import CustomInput from "../../forms/input/Input";
import CardContent from "@mui/material/CardContent";
import CustomOutlinedSelect from "../../forms/select/OutlinedCustomSelect";
import DatePickerInput from "../../forms/input/DatePickerInput";
import CustomDataTable from "../table/CustomTable";

// React icons
import { IoIosAdd } from "react-icons/io";
import { MdDelete } from "react-icons/md";
import { UnifiedIcon } from "../Icon/UnifiedIcon";

const RegisterRuleBook: React.FC = () => {
  const [searchOpen, setSearchOpen] = useState(false);

  const COLUMNS = [
    "S.no.",
    "Register Rule ID",
    "Register Rule Code",
    "Use Rule",
    "Action",
  ];

  const rowsContent = (
    <TableRow
      sx={{
        height: "50px",
      }}
      className="custom_table_tbody"
    >
      <TableCell sx={{ padding: "10px", width: "5%" }}>
        <Typography className="custom_table_tbody_cell">1</Typography>
      </TableCell>
      <TableCell sx={{ padding: "10px", width: "40%" }}>
        <Stack direction={"row"} gap={"10px"} alignItems={"center"}>
          <CustomInput sx={{ width: "85%" }} />
          <Link href="#" color="#1280E7" sx={{ width: "15%" }}>
            Register Rule ID
          </Link>
        </Stack>
      </TableCell>
      <TableCell sx={{ padding: "10px", width: "15%" }}>
        <Typography className="custom_table_tbody_cell">
          TOT_ACT_KWH_IMP
        </Typography>
      </TableCell>
      <TableCell sx={{ padding: "10px", width: "20%" }}>
        <CustomOutlinedSelect />
      </TableCell>
      <TableCell sx={{ padding: "10px", width: "5%" }}>
        <Box
          sx={{
            background: true
              ? "linear-gradient(180deg, #1976d2 0%, #0396FF 100%)"
              : "linear-gradient(180deg, #FF6B6B 0%, #FF3D3D 100%);",
            padding: "8px",
            borderRadius: "3px",
            width: "fit-content",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {true ? (
            <UnifiedIcon icon={IoIosAdd} color="#ffffff" fontSize="20px" />
          ) : (
            <UnifiedIcon icon={MdDelete} color="#ffffff" fontSize="20px" />
          )}
        </Box>
      </TableCell>
    </TableRow>
  );

  return (
    <Layout>
      <Card className="register_rule_book_title_card">
        <Typography variant="h5">Register Rule Book</Typography>
      </Card>

      <Card
        className="register_rule_book_search_card"
        sx={{
          overflow: "visible",
          position: "relative",
        }}
      >
        <Typography variant="body1" fontWeight={600}>
          Register Rule Book ID
        </Typography>

        <Stack direction={"row"} gap={"10px"} alignItems={"center"}>
          <CustomSearchBox
            placeholder={"Enter 10 Digit"}
            width={"500px"}
            height={"40px"}
            handleSearchToggle={() => setSearchOpen(!searchOpen)}
            searchOpen={searchOpen}
            dialogBody={
              <Stack direction={"column"} gap={"20px"}>
                <CustomInput label={"First Name"} />
                <CustomInput label={"Register Rule Types"} />
                <ContainedButton
                  label={"Submit"}
                  sx={{
                    width: "100%",
                    fontWeight: 600,
                    color: "#ffffff",
                  }}
                />
              </Stack>
            }
          />

          <ContainedButton
            label={"Save"}
            sx={{
              width: "fit-content",
              fontWeight: 600,
              height: "35px",
              color: "#ffffff",
            }}
          />
        </Stack>
      </Card>

      <Card sx={{ mt: "20px" }}>
        <CardHeader
          title={
            <Typography variant="body1" fontWeight={"500"}>
              Register Rule Book
            </Typography>
          }
        />
        <Divider />

        <CardContent>
          <Grid container spacing={2}>
            <Grid size={{ xs: 12, md: 4, lg: 4 }}>
              <DatePickerInput
                label={"Rule Book Activation Date Time:"}
                placeholder={"dd/mm/yyyy hh:mm"}
              />
            </Grid>

            <Grid size={{ xs: 12, md: 8, lg: 8 }}></Grid>

            <Grid size={{ xs: 12, md: 4, lg: 4 }} mt={"10px"}>
              <CustomInput sx={{ width: "500px" }} label={"Rule Book Code:"} />
            </Grid>

            <Grid size={{ xs: 12, md: 2, lg: 2 }} mt={"10px"}>
              <ContainedButton
                label={"Add New Register Rule"}
                sx={{
                  width: "fit-content",
                  fontWeight: 600,
                  mt: "28px",
                  height: "40px",
                  color: "#ffffff",
                }}
              />
            </Grid>

            <Grid size={{ xs: 12, md: 12, lg: 12 }} mt={"10px"}>
              <CustomDataTable
                sx={{ maxHeight: "600px" }}
                columns={COLUMNS}
                pagination={false}
                rowsContent={rowsContent}
              />
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </Layout>
  );
};

export default RegisterRuleBook;
